var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFFAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9241 25.125L23.0393 26.9555M23.0393 26.9555C22.5487 25.6147 21.0361 24.9155 19.6608 25.3937C18.2855 25.872 17.5683 27.3466 18.0588 28.6874C18.5494 30.0282 20.0619 30.7275 21.4372 30.2493C22.5766 29.8531 23.2644 28.7729 23.1879 27.6516C23.1725 27.4272 23.1266 27.2011 23.0476 26.9785C23.0448 26.9709 23.0421 26.9632 23.0393 26.9555ZM23.0393 26.9555L20.2125 18.1855L27.8465 15.4373L30.9001 23.9873M23.0393 26.9555L30.9001 23.9873M19.4991 24.9183L15.6322 14.2159L13.8 13.2998M30.9001 23.9873L24.2521 26.4976M23.904 16.8566L24.8392 19.0749",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickIcon);
export default __webpack_public_path__ + "43ae78cbc4896a284d7f668a0a686970.svg";
export { ForwardRef as ReactComponent };